/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { createMuiTheme } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import blueGrey from "@material-ui/core/colors/blueGrey";
import blue from "@material-ui/core/colors/blue";

const theme = createMuiTheme({
  overrides: {
    MuiSwitch: {
      colorPrimary: {
        "&$checked": {
          // Controls checked color for the thumb
          color: blue[700]
        }
      },
      track: {
        "$checked$checked + &": {
          // Controls checked color for the track
          backgroundColor: blue[700]
        }
      }
    },
    MuiCssBaseline: {
      "@global": {
        html: {
          fontSize: "14px",
        },
        body: {
          fontSize: "1rem",
        },
      },
    },
    MuiInputBase: {
      root: {
        fontSize: "1rem",
      },
    },
    MuiTableCell: {
      root: {
        fontSize: "1rem",
        boxSizing: "content-box",
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: "1rem",
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: "rgba(75, 75, 75, 1)",
        fontSize: "0.8571428571rem", // 12px
      },
      tooltipPlacementBottom: {
        margin: "4px",

        "@media (min-width: 0px)": {
          margin: "4px 0",
        },
      },
    },
    MuiCheckbox: {
      root: {
        "&$checked": { color: `${blue[400]} !important` },
      },
    },
  },
  props: {
    MuiFormControl: {
      margin: "dense",
    },
  },
  palette: {
    background: {
      darkGrey: grey[700],
      lightGrey: grey[300],
      headerBlue: "#DDEDF8",
    },
    primary: {
      main: blueGrey[700],
      dark: blueGrey[800],
      light: blueGrey[500],
      lighter: blueGrey[50],
      hover: blueGrey[100],
      yellow: "#F3C14F",
      blue: "#3F89DE",
      green: "#059471",
      red: "#F00000",
    },
    link: {
      main: blue[400],
    },
  },
  typography: {
    h1: {
      fontSize: "2.2857142857rem", // 32px
    },
    h4: {
      fontSize: "1.125rem",
    },
    h5: {
      fontSize: "1.8rem",
    },
    body1: {
      fontSize: "1rem",
    },
  },
});

export default theme;
